import { Project } from "@models/project";
export function makeProjectController() {
    let projects = [];
    function fetchProjects(source, db) {
        if (source === "localStorage" && localStorage) {
            let dataJSON = localStorage.getItem("tbProjects");
            if (!dataJSON) {
                dataJSON = "[]";
                localStorage.setItem("tbProjects", dataJSON);
            }
            try {
                projects = Project.fromJSON(dataJSON);
            }
            catch (error) {
                console.error("failed to fetch projects:", error);
            }
        }
    }
    function addProject(project) {
        project.position = projects.length;
        projects.push(project);
        saveProjectsInLS();
    }
    function updateProject(id, data) {
        const project = getProjectByID(id);
        if (project) {
            project.name = data.name;
            project.description = data.description;
            project.deadline = data.deadline;
            project.priority = data.priority;
            project.notes = data.notes;
            saveProjectsInLS();
        }
        else {
            console.error("Project not found");
        }
    }
    function deleteProject(id) {
        const idx = projects.findIndex((t) => t.id === id);
        if (idx >= 0) {
            projects.splice(idx, 1);
            position.recompute();
            saveProjectsInLS();
        }
        else {
            console.error("Project not found");
        }
    }
    function getProjects() {
        return projects;
    }
    function getProjectByDeadline(deadline) {
        return projects.filter((t) => t.deadline === deadline);
    }
    function getProjectByID(id) {
        return projects.find((t) => t.id === id);
    }
    const position = {
        recompute: function () {
            projects.forEach((p, i) => (p.position = i));
        },
        sort: function () {
            projects.sort((a, b) => a.position - b.position);
        },
        change: function (from, to) {
            const p = projects.splice(from, 1)[0];
            projects.splice(to, 0, p);
            saveProjectsInLS();
        },
    };
    function saveProjectsInLS() {
        try {
            localStorage.setItem("tbProjects", JSON.stringify(projects));
        }
        catch (error) {
            console.error("failed to save projects:", error);
        }
    }
    return {
        fetchProjects,
        addProject,
        updateProject,
        deleteProject,
        getProjects,
        getProjectByID,
        getProjectByDeadline,
        position,
    };
}
